import BaseError from '@whr/core_utils/baseError.js';
export var StorageProviderNotFoundErrorCode;
(function (StorageProviderNotFoundErrorCode) {
    StorageProviderNotFoundErrorCode["STORAGE_PROVIDER_NOT_FOUND"] = "STORAGE_PROVIDER_NOT_FOUND";
})(StorageProviderNotFoundErrorCode || (StorageProviderNotFoundErrorCode = {}));
export class StorageProviderNotFoundError extends BaseError {
    constructor(message, originalError) {
        super(StorageProviderNotFoundErrorCode.STORAGE_PROVIDER_NOT_FOUND, message, originalError, 500);
    }
}
//# sourceMappingURL=storage_provider_not_found_error.js.map